const EMAIL_SUFFIXES = ['@iitb.ac.in', '@iitbombay.org'];

export function normalizeUsername(rollPart, emailType) {
  let id = (rollPart || '').trim();
  const lower = id.toLowerCase();
  for (const suffix of EMAIL_SUFFIXES) {
    if (lower.endsWith(suffix)) {
      id = id.slice(0, -suffix.length).trim();
      break;
    }
  }
  return id + emailType;
}
